import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import './styles.scss'
import { GalleryDesktop } from './galleryHandler'
import sanitizedContentData from '../../shared/utils/sanitizedContentData'
import { InViewSimpleTransition } from '../../shared/utils/animations/transitions'
import { useWindowSize } from '@uidotdev/usehooks'

ContentPanelPillGallery.propTypes = {
  data: PropTypes.object,
}

const LinkButton = ({ link_button }) => {
  return (
    <React.Fragment>
      {link_button?.title && (
        <a href={link_button?.url} className="action-button" target={link_button.target}>
          {link_button?.title}
        </a>
      )}
    </React.Fragment>
  )
}

LinkButton.propTypes = {
  link_button: PropTypes.object,
}
const MAX_TITLE_LENGHT_FOR_INLINE = 75
const MIN_DESKTOP_WIDTH = 1024
const MID_DESKTOP_WIDTH = 1220
const MAX_DESKTOP_WIDTH = 1440

const isInRangeTooLong = (value) => value >= MIN_DESKTOP_WIDTH && value <= MAX_DESKTOP_WIDTH
const isInRangeMidLong = (value) => value >= MIN_DESKTOP_WIDTH && value <= MID_DESKTOP_WIDTH
const hasLongTitle = (value, stringSize = MAX_TITLE_LENGHT_FOR_INLINE) =>
  String(value).trim().length > stringSize
export default function ContentPanelPillGallery({ data }) {
  const targetRef = useRef(null)
  const { width } = useWindowSize()

  // const onMobileScreen = screenWidth <= MOBILE_MAX_WIDTH_LIMITS.MAX_MOBIL_DEVICES;
  const normalPadding = 'py-[112px] lg:py-[158px]'
  const shortPadding = 'pt-[112px] pb-[67px] lg:pt-[158px] lg:pb-[130px]'
  const parseProps = {
    acf_fc_layout: data?.acf_fc_layout ?? 'ContentPanelWithImgageGallery',
    top_title: data?.top_title ?? '',
    main_title: data?.main_title ?? '',
    content: data.main_content ?? data?.content ?? '',
    link_button: data?.link_button_action,
    animate_gallery: data?.animate_gallery,
    background_color: data?.background_color ?? 'eerie_black',
    use_short_bottom: data?.use_short_bottom,
    gallery: data.gallery ?? [],
  }

  const hasTooLongTitle = hasLongTitle(parseProps.main_title) && isInRangeTooLong(width)
  const hasBitLongTitle = hasLongTitle(parseProps.main_title, 60) && isInRangeMidLong(width)

  return (
    <section
      className={`ContentPanelPillGallery_HomePage ${parseProps.background_color} ${parseProps?.use_short_bottom ? shortPadding : normalPadding}`}
    >
      <div
        className={`main-section-container ${(hasTooLongTitle || hasBitLongTitle) && 'has-long-title'}`}
      >
        <div className="container-left">
          <InViewSimpleTransition type={'fade'} parent={targetRef}>
            <pre>{parseProps?.top_title}</pre>
            <h2>{parseProps?.main_title}</h2>
            <div dangerouslySetInnerHTML={sanitizedContentData(parseProps?.content)}></div>
            <LinkButton link_button={parseProps.link_button} />
          </InViewSimpleTransition>
        </div>
        <div className="container-right">
          <div className="col-9">
            <GalleryDesktop
              animate_gallery={parseProps.animate_gallery}
              gallery={parseProps.gallery}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
